/*
 * This mixin is primarily used to share code for the "interval" selector
 * on the registration and subscription screens, which is used to show
 * all of the various subscription plans offered by the application.
 */
module.exports = {

  data() {
    return {
      hiddenPlans: [
        'snazzydocs-beta-monthly',
      ],

      enterprisePlans: [
        'snazzydocs-ent-monthly-24999-v1',
        'snazzydocs-ent-yearly-274999-v1'
      ],
    }
  },

  computed: {

    hiddenPlansFromUser() {
      return this.userCanSeeEnterprisePlans ? this.hiddenPlans : this.hiddenPlans.concat(this.enterprisePlans)
    },

    userCanSeeEnterprisePlans() {
      return this.spark.hasOwnProperty('userCanSeeEnterprisePlans') ? this.spark.userCanSeeEnterprisePlans : false
    },


    /**
     * Get all of the plans for the active interval.
     */
    plansForActiveInterval() {
      console.log('[ plansForActiveInterval ]');

      return _.filter(this.plans, plan => {
        // return plan.active && (plan.price == 0 || plan.interval == this.activeInterval);
        return plan.active && !this.hiddenPlansFromUser.includes(plan.id) && (plan.price == 0 || plan.interval == this.activeInterval);
      });
    },
  },

};
